import { baseApi } from '../../../shared/api/baseApi';
import type { UsersRequestsDto } from '../model/dto';
import { toUsersRequests } from '../model/mappers';
import type { UsersRequestsQuery, UsersRequestsResult } from '../model/types';

const ENDPOINT = '/api/admin/users/report';

const TAG = 'UserRequests' as const;

export const usersRequestsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getUsersRequests: build.query<UsersRequestsResult, UsersRequestsQuery>({
            query: ({ since, till, sortBy, sortOrder, query = '' }) => ({
                url: ENDPOINT,
                params: {
                    since,
                    till,
                    ...(sortBy ? { sort_by: sortBy, sort_order: sortOrder ?? 'desc' } : {}),
                    query,
                },
            }),
            transformResponse: (response: UsersRequestsDto) => toUsersRequests(response),
            providesTags: [{ type: TAG, id: 'LIST' }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetUsersRequestsQuery } = usersRequestsApi;